import {Routes} from '@angular/router';
import {AdminShellComponent} from './shell/admin-shell/admin-shell.component';
import {UsersPageComponent} from './pages/users-page/users-page.component';
import {AuditPageComponent} from './pages/audit-page/audit-page.component';
import {SupportPageComponent} from './pages/support-page/support-page.component';
import {AuditDetailPageComponent} from './pages/audit-detail-page/audit-detail-page.component';
import {OverviewPageComponent} from './pages/overview-page/overview-page.component';
import {FeatureFlagsPageComponent} from './pages/feature-flags-page/feature-flags-page.component';
import {DiscordBotPageComponent} from './pages/discord-bot-page/discord-bot-page.component';
import {SchedulersPageComponent} from './pages/schedulers-page/schedulers-page.component';
import {TwitchBotsPageComponent} from './pages/twitch-bots-page/twitch-bots-page.component';

export const routes: Routes = [
  {
    path: '',
    component: AdminShellComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'overview' },
      { path: 'overview', component: OverviewPageComponent },
      { path: 'features', component: FeatureFlagsPageComponent },
      { path: 'schedulers', component: SchedulersPageComponent },
      { path: 'twitch-bots', component: TwitchBotsPageComponent },
      { path: 'discord-bot', component: DiscordBotPageComponent },
      { path: 'users', component: UsersPageComponent },
      { path: 'users/:id', component: UsersPageComponent },
      { path: 'support', component: SupportPageComponent },
      { path: 'audit', component: AuditPageComponent },
      { path: 'audit/:id', component: AuditDetailPageComponent }
    ]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
